import {DrawingDataItem, DrawingDataItemDrawResult, DrawingDataItemPoint} from "../drawingOnImageDrawingElement.model";

export class DrawingDataItemAngle extends DrawingDataItem {
    constructor(subTypeValue: 'HORIZONTAL' | 'VERTICAL' | 'CUSTOM') {
        super();
        this.typeValue = 'angle';
        this.properties = {
            origin: undefined,
        }
        this.subTypeValue = subTypeValue;
    }

    public getPointsToMove(): DrawingDataItemPoint[] {
        return [
            DrawingDataItemPoint.fromVisiblePoint(this.properties.origin),
            DrawingDataItemPoint.fromVisiblePoint(this.properties.vertex),
            DrawingDataItemPoint.fromNotVisiblePoint(this.properties.originalVertex),
            DrawingDataItemPoint.fromVisiblePoint(this.properties.destination)
        ];
    }



    public onMouseDown(canvasRelativeX: number, canvasRelativeY: number): DrawingDataItemDrawResult {
        if (!this.properties.vertex) {
            this.properties.origin = {
                x: canvasRelativeX,
                y: canvasRelativeY,
            }

            this.properties.vertex = {
                x: canvasRelativeX,
                y: canvasRelativeY
            }
            return {
                stillDrawing: true,
                changed: true
            };
        } else if (!this.properties.destination) {
            this.properties.destination = {
                x: canvasRelativeX,
                y: canvasRelativeY
            }
            return {
                stillDrawing: true,
                changed: true
            };
        } else {
            this.changeCoordinatesAccordingToSubTypeValue();
            return {
                stillDrawing: false,
                changed: false
            };
        }
    }

    public onMouseMove(canvasRelativeX: number, canvasRelativeY: number): DrawingDataItemDrawResult {
        if (this.properties.destination) {
            this.properties.destination = {
                x: canvasRelativeX,
                y: canvasRelativeY
            }

            this.properties.originalDestination = {
                x: canvasRelativeX,
                y: canvasRelativeY
            }

            // this.changeCoordinatesAccordingToSubTypeValue();

            return {
                changed: true,
                stillDrawing: true
            };
        } else if (this.properties.origin) {
            this.properties.origin = {
                x: canvasRelativeX,
                y: canvasRelativeY
            }
            this.changeCoordinatesAccordingToSubTypeValue();
            return {
                changed: true,
                stillDrawing: true
            };
        }

        return undefined;
    }


    protected subTypeValueChanged() {
        this.changeCoordinatesAccordingToSubTypeValue()
    }

    private changeCoordinatesAccordingToSubTypeValue() {
        if (this.properties?.destination && this.properties.vertex) {
            if (this.subTypeValue === 'HORIZONTAL') {
                this.properties.destination.x = this.properties.originalDestination.x;
                this.properties.destination.y = this.properties.vertex.y;
            } else if (this.subTypeValue === 'VERTICAL') {
                this.properties.destination.x = this.properties.vertex.x;
                this.properties.destination.y = this.properties.originalDestination.y;
            } else {
                this.properties.destination.x = this.properties.originalDestination.x;
                this.properties.destination.y = this.properties.originalDestination.y;
            }
        }
    }

    public draw(ctx: CanvasRenderingContext2D) {
        this.changeCoordinatesAccordingToSubTypeValue();

        if (this.properties.vertex) {
            ctx.beginPath();
            this.applyCommonToCanvas(ctx);
            ctx.moveTo(this.properties.origin.x, this.properties.origin.y);
            ctx.lineTo(this.properties.vertex.x, this.properties.vertex.y);
            ctx.stroke();

            if (this.properties.destination) {
                ctx.beginPath();
                this.applyCommonToCanvas(ctx);
                ctx.moveTo(this.properties.vertex.x, this.properties.vertex.y);
                ctx.lineTo(this.properties.destination.x, this.properties.destination.y);
                ctx.stroke();
            }
        }

        if (this.properties.origin && this.properties.vertex && this.properties.destination) {
            // Calculer les angles des deux segments par rapport au vertex
            const angle1 = Math.atan2(this.properties.origin.y - this.properties.vertex.y, this.properties.origin.x - this.properties.vertex.x);
            const angle2 = Math.atan2(this.properties.destination.y - this.properties.vertex.y, this.properties.destination.x - this.properties.vertex.x);

            // Calculer la différence d'angle en radians et la normaliser dans l'intervalle [-PI, PI]
            let diff = angle2 - angle1;
            if (diff > Math.PI) {
                diff -= 2 * Math.PI;
            } else if (diff < -Math.PI) {
                diff += 2 * Math.PI;
            }
            const angleDiff = Math.abs(diff);

            // Choisir un rayon pour l'arc (ajustable)
            const arcRadius = 30;

            // Déterminer les angles de départ et d'arrivée pour tracer l'arc de l'angle intérieur
            let startAngle: number, endAngle: number, anticlockwise: boolean;
            if (diff >= 0) {
                startAngle = angle1;
                endAngle = angle1 + angleDiff;
                anticlockwise = false;
            } else {
                startAngle = angle1;
                endAngle = angle1 - angleDiff;
                anticlockwise = true;
            }

            // Dessiner l'arc de cercle
            ctx.beginPath();
            ctx.arc(this.properties.vertex.x, this.properties.vertex.y, arcRadius, startAngle, endAngle, anticlockwise);
            ctx.stroke();

            // Dessiner un cercle plein au vertex pour le mettre en évidence
            const vertexRadius = this.common.thickness + 5; // Ajustez cette valeur si nécessaire
            ctx.beginPath();
            ctx.arc(this.properties.vertex.x, this.properties.vertex.y, vertexRadius, 0, 2 * Math.PI);
            ctx.fillStyle = this.common.color;
            ctx.fill();

            // Calculer l'angle médian pour positionner le texte (un peu à l'extérieur de l'arc)
            const midAngle = startAngle + (endAngle - startAngle) / 2;
            // Ajouter un décalage qui tient compte de l'arc et de l'épaisseur du trait
            const offset = arcRadius + this.common.thickness + 10;
            const textX = this.properties.vertex.x + offset * Math.cos(midAngle);
            const textY = this.properties.vertex.y + offset * Math.sin(midAngle);


            // Convertir l'angle en degrés
            const degrees = Math.round(angleDiff * 180 / Math.PI);

            // Afficher le texte
            ctx.font = this.common.size +  "px Arial";
            ctx.fillStyle = this.common.color;
            ctx.fillText(degrees + "°", textX, textY);
        }
    }
}